import { useEffect } from "react";

const DEFAULTS = { captured: false };

function captureDefaults() {
  if (DEFAULTS.captured) return;
  DEFAULTS.captured = true;
  DEFAULTS.title = document.title;
  DEFAULTS.description = document.head.querySelector('meta[name="description"]')?.getAttribute("content") || "";
  DEFAULTS.ogTitle = document.head.querySelector('meta[property="og:title"]')?.getAttribute("content") || "";
  DEFAULTS.ogDescription = document.head.querySelector('meta[property="og:description"]')?.getAttribute("content") || "";
  DEFAULTS.ogType = document.head.querySelector('meta[property="og:type"]')?.getAttribute("content") || "website";
  DEFAULTS.ogImage = document.head.querySelector('meta[property="og:image"]')?.getAttribute("content") || "";
}

function setMeta(attribute, key, content) {
  let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  if (content) element.setAttribute("content", content);
  else element.remove();
}

function setCanonical(url) {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!url) {
    link?.remove();
    return;
  }
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
}

export default function usePageMeta({ title, description, canonicalUrl, ogTitle, ogDescription, ogImage, ogUrl, type = "article", publishedTime } = {}) {
  useEffect(() => {
    if (!title) return undefined;
    captureDefaults();

    document.title = title;
    setMeta("name", "description", description || "");
    setMeta("property", "og:title", ogTitle || title);
    setMeta("property", "og:description", ogDescription || description || "");
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", ogUrl || canonicalUrl || window.location.href);
    if (ogImage) {
      setMeta("property", "og:image", ogImage);
      setMeta("name", "twitter:card", "summary_large_image");
      setMeta("name", "twitter:image", ogImage);
    } else {
      setMeta("name", "twitter:card", "summary");
    }
    setMeta("name", "twitter:title", ogTitle || title);
    setMeta("name", "twitter:description", ogDescription || description || "");
    if (publishedTime) setMeta("property", "article:published_time", publishedTime);
    setCanonical(canonicalUrl || window.location.href.split("#")[0]);

    return () => {
      document.title = DEFAULTS.title;
      setMeta("name", "description", DEFAULTS.description);
      setMeta("property", "og:title", DEFAULTS.ogTitle);
      setMeta("property", "og:description", DEFAULTS.ogDescription);
      setMeta("property", "og:type", DEFAULTS.ogType);
      setMeta("property", "og:image", DEFAULTS.ogImage);
      setMeta("property", "og:url", "");
      setMeta("name", "twitter:card", "");
      setMeta("name", "twitter:title", "");
      setMeta("name", "twitter:description", "");
      setMeta("name", "twitter:image", "");
      setMeta("property", "article:published_time", "");
      setCanonical(null);
    };
  }, [title, description, canonicalUrl, ogTitle, ogDescription, ogImage, ogUrl, type, publishedTime]);
}
